//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['query'],
    data(){
        return{
            dictionary:{
                search: 'Búsqueda: ',
                price_max: 'Hasta $',
                price_min: 'Desde $',
                year_min: 'Desde ',
                year_max: 'Hasta ',
                mileage_min: 'Desde ',
                mileage_max: 'Hasta ',
            }
        }
    },
    methods:{
        show(v,k){
            var res = ''
            function capitalize(v){return v.charAt(0).toUpperCase() + v.slice(1)}
            if(this.dictionary[k]){
                res = this.dictionary[k]
            }
            if(Number(v) && k.includes('price')){
                return res + this.$store.getters.numFormater(Number(v))
            }else if(Number(v) && k.includes('mileage')){
                return res + this.$store.getters.numFormater(Number(v)) + 'km'
            }else if(Number(v) && k.includes('year')){
                return res + v
            }else{
                return res + capitalize(v).replace(/-/g, ' ')
            }
        }
    }
}
